import { OnboardingStepper } from "components/Layout/OnboardingStepper";
import { useOnboardingStudent } from "./hooks";
import { RequirementsSelector, GradClassCreator, Success } from "./steps";
import { useNavigate } from "react-router-dom";
import { User } from "types/user";

export const OnboardingStudent = () => {
  const navigate = useNavigate();
  const {
    state,
    availableRequirements,
    selectedRequirements,
    handleAddRequirement,
    handleRemoveRequirement,
    requirementsError,
    goNextFromRequirements,
    coaches,
    selectedCoaches,
    handleAddCoach,
    handleRemoveCoach,
    handleChangeCoaches,
    mentorsOptional,
    tags,
    handleAddTag,
    handleRemoveTag,
    previousStep,
    goToStep,
    handleComplete,
  } = useOnboardingStudent();

  const steps = [
    {
      label: "Requirements",
      component: (
        <RequirementsSelector
          organizationId={state.organizationId}
          allRequirements={availableRequirements}
          selectedRequirements={selectedRequirements}
          onAddRequirement={handleAddRequirement}
          onRemoveRequirement={handleRemoveRequirement}
          onNext={goNextFromRequirements}
          errorMessage={requirementsError}
        />
      ),
      onClickStep: () => goToStep(0),
    },
    {
      label: "Details",
      component: (
        <GradClassCreator
          tags={tags}
          onAddTag={handleAddTag}
          onRemoveTag={handleRemoveTag}
          onBack={previousStep}
          onComplete={(values) => handleComplete(values)}
          coaches={coaches as User[]}
          selectedCoaches={selectedCoaches as User[]}
          mentorsOptional={mentorsOptional}
          onAddCoach={handleAddCoach}
          onRemoveCoach={handleRemoveCoach}
          onChangeCoaches={handleChangeCoaches}
        />
      ),
      onClickStep: () => goToStep(1),
    },
    {
      label: "Success",
      component: <Success onGoHome={() => navigate("/")} />,
      onClickStep: undefined,
    },
  ];

  return (
    <OnboardingStepper
      steps={steps}
      activeStep={state.activeStep}
      title="Student Onboarding"
    />
  );
};
